// extracted by mini-css-extract-plugin
export default {"cls1":"FollowActionButton-cls1_RWC","cls2":"FollowActionButton-cls2_x3g FollowActionButton-cls1_RWC"};